import { Button } from "@/components/ui/button";
import { usePendencias } from "@/contexts/pendencias-context";
import { AlertTriangle } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface PendenciaCardProps {
  mode?: "home" | "screen";
  screenName?: string;
  className?: string;
  onAction?: () => void;
}

export default function PendenciaCard({
  mode = "home",
  screenName,
  className = "",
  onAction,
}: PendenciaCardProps) {
  const { getPendenciaMaisImportante, getPendenciaPorTela, isLoading } =
    usePendencias();
  const navigate = useNavigate();

  if (isLoading) return null;

  const pendencia =
    mode === "home"
      ? getPendenciaMaisImportante()
      : screenName
      ? getPendenciaPorTela(screenName)
      : undefined;

  if (!pendencia) return null;

  const handleClick = () => {
    if (onAction) {
      onAction();
      return;
    }

    if (mode === "home") {
      const routes: Record<string, string> = {
        "Dados pessoais": "/cliente/dados-pessoais",
        "Cotações em aberto": "/cliente/cotacoes-abertas",
        "FAQ / Suporte": "/cliente/ajuda/chamados-abertos",
        "Histórico de transportes": "/cliente/contratos",
      };

      const route = routes[pendencia.tela];
      if (route) {
        navigate(route);
      }
    }
  };

  const showButton = mode === "home" || !!onAction;

  return (
    <div
      className={`flex items-center justify-between rounded-[20px] border border-n-green bg-n-beige md:px-8 md:py-5 px-5 py-3 ${className}`}
    >
      <div className="flex items-center gap-2 flex-1 min-w-0">
        <AlertTriangle className="w-6 h-6 text-n-green flex-shrink-0" />
        <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-2 min-w-0">
          <span className="font-semibold text-n-green text-base sm:text-lg">
            {pendencia.texto}
          </span>
          {mode === "screen" && (
            <span className="text-sm text-n-green/70">
              ({pendencia.qtd} {pendencia.qtd === 1 ? "item" : "itens"})
            </span>
          )}
        </div>
      </div>

      {showButton && (
        <Button
          type="button"
          size="small"
          onClick={handleClick}
          className="flex-shrink-0 ml-4"
        >
          {mode === "home" ? "Finalizar" : "Ação"}
        </Button>
      )}
    </div>
  );
}
